// Global touch guard for mobile: distinguishes deliberate taps from
// scrolling/swiping. When a finger moves more than a small threshold between
// touchstart and touchend, the resulting click is a scroll artifact and is
// suppressed. Real taps (little or no movement) pass through untouched.
const TAP_THRESHOLD_PX = 10;

export function installTapScrollGuard() {
  if (typeof window === "undefined" || !("ontouchstart" in window)) return;

  let startX = 0;
  let startY = 0;
  let moved = false;

  window.addEventListener(
    "touchstart",
    (e) => {
      const t = e.touches[0];
      if (!t) return;
      startX = t.clientX;
      startY = t.clientY;
      moved = false;
    },
    { passive: true, capture: true }
  );

  window.addEventListener(
    "touchmove",
    (e) => {
      const t = e.touches[0];
      if (!t) return;
      if (
        Math.abs(t.clientX - startX) > TAP_THRESHOLD_PX ||
        Math.abs(t.clientY - startY) > TAP_THRESHOLD_PX
      ) {
        moved = true;
      }
    },
    { passive: true, capture: true }
  );

  // A real mouse/pen press clears the flag so hybrid devices (touch laptops)
  // never get a legitimate click swallowed after a touch scroll.
  window.addEventListener(
    "pointerdown",
    (e) => {
      if (e.pointerType && e.pointerType !== "touch") moved = false;
    },
    { passive: true, capture: true }
  );

  // Capture phase: runs before any button/card/link onClick handlers.
  window.addEventListener(
    "click",
    (e) => {
      if (!moved) return;
      moved = false;
      e.preventDefault();
      e.stopPropagation();
    },
    true
  );
}
